// extracted by mini-css-extract-plugin
export default {"google":"SnsSelect_google_CyD_g","kakao":"SnsSelect_kakao_LzLTb","naver":"SnsSelect_naver_zPEBf","facebook":"SnsSelect_facebook_UQchh","apple":"SnsSelect_apple_Ozh9D"};